import { create } from 'zustand';

import { TextToStructuredObservation } from '@/api';

import { ScrollSyncState } from './use-scroll-sync.model';

export const useScrollSyncStore = create<ScrollSyncState>((set) => ({
  clearScrollTarget: () => {
    set({
      scrollTriggerTime: 0,
      targetFinding: null,
    });
  },

  scrollToFinding: (finding: TextToStructuredObservation) => {
    set({
      scrollTriggerTime: Date.now(),
      targetFinding: finding,
    });
  },

  scrollTriggerTime: 0,
  targetFinding: null,
}));
